import styled from 'styled-components';

import { ColorName } from 'types';

import { pickColor } from 'themes/helpers/pickColor';
import { getFontScale } from 'themes/mixins/getFontScale';

import { Headline } from 'components/Headline';

export type StyledNotificationType = {
  notificationColor?: ColorName;
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
`;

const Wrapper = styled.div<StyledNotificationType>`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 2.4rem;
  height: 2.4rem;
  padding: 0.3rem 0.7rem;

  background-color: ${({ notificationColor }) => pickColor(notificationColor || 'red')};
  border-radius: 50%;
`;

const Label = styled(Headline)`
  text-transform: capitalize;
`;

const Item = styled.span`
  color: ${pickColor('white')};

  ${getFontScale('xs')}
`;

export { Container, Wrapper, Label, Item };
